import { firmwareApi } from 'farmx-api';
import sampleData from '../../__mocks__/data/deviceList';
import { editConfig } from '../../__mocks__/data/editConfigJSON';

// This mock API function will replaced actual API in the future
function mockApi(url: any, config: any, type: String) {
  // Parse the URL
  const urlObj = new URL(url);

  // Extract query parameters
  const params = new URLSearchParams(urlObj?.search);
  const deviceType = params.get('deviceType');
  const block = params.get('block');
  const ranch = params.get('ranch');
  const entity = params.get('entity');
  const firmwareVersion = params.get('firmwareVersion');
  const firmwareType = params.get('firmwareType');

  const filteredData = sampleData.filter((d: any) => d?.type === deviceType
   || (d?.ranch === ranch || d?.block === block || d?.entity === entity));

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Define mock responses based on URL
      if (type === 'nodeList') {
        resolve({
          status: 200,
          json: () => Promise.resolve(filteredData),
        });
      } else if (type === 'config') {
        resolve({
          status: 200,
          json: () => Promise.resolve(editConfig),
        });
      }  else if (type === 'firmwareType') {
        resolve({
          status: 200,
          json: () => Promise.resolve({
            deviceType,
            firmwareType,
            versionsAvailable: []
          }),
        });
      } else if (type === 'updateConfig') {
        resolve({
          status: 200,
          json: () => Promise.resolve({
            configApplyStatus: 'in progress',
            errorMessage: undefined,
            errorCode: 0,
          }),
        });
      } else if (type === 'updateNode') {
        resolve({
          status: 200,
          json: () => Promise.resolve({
            firmwareUpdateStatus: 'started',
            error: undefined,
          }),
        });
      } else {
        reject({
          status: 500,
          message: 'Internal Server Error',
        });
      }
    }, 500);
  });
}

// below functions will be removed in the future
export async function getNodeData({
  type, block, ranch,
  entity
}: any) {
  const url = `https://api.example.com/nodes?deviceType=${type}&block=${block}&ranch=${ranch}&entity=${entity}`;
  const response = await mockApi(url, null, 'nodeList');
  const data = await response.json();
  return data;
}

export async function getConfigJSON({ type, firmwareVersion }: any) {
  const url = `https://api.example.com/config?deviceType=${type}&firmwareVersion=${firmwareVersion}`;
  const response = await mockApi(url, null, 'config');
  const data = await response.json();
  return data;
}

export async function getFirmwareVersions({ type, firmwareType }: any) {
  const url = `https://api.example.com/firmwareType?deviceType=${type}&firmwareType=${firmwareType}`;
  const response = await mockApi(url, {type, firmwareType}, 'firmwareType');
  const data = await response.json();
  return data;
}

export async function updateNodeFirmware({ deviceList, firmwareVersion }: any) {
  const url = 'https://api.example.com/update/node';
  const response = await mockApi(url, { deviceList, firmwareVersion }, 'updateNode');
  const data = await response.json();
  return data;
}

export const checkIsValidJSON = (obj: any) => {
  let isJSONValid = false;
  try {
    const value = obj?.trim(); // Trim whitespace
    const parsed = JSON.parse(value);

    // Check if parsed JSON is strictly an object
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      isJSONValid = true; // Valid JSON object
    } else {
      isJSONValid = false; // Not a valid JSON object
    }
  } catch {
    isJSONValid = false; // Invalid JSON
  }
  return isJSONValid;
};

export const fetchFirmwareData = async (deviceType : string) => {
  try {
    const response = await firmwareApi.getFirmwareList(deviceType);
    return response?.data?.results || [];
  } catch (error) {
    console.error('Error fetching firmware data:', error);
    return [];
  }
};

export const fetchFirmwareUpgrade = async (nodes: string[], firmwareId: number, deviceType :string) => {
  try {
    const response = await firmwareApi.firmwareUpgrade(nodes, firmwareId, deviceType)
    return response.data;
  } catch (error) {
    console.error("Firmware upgrade failed:", error);
    throw error; // Re-throw for UI handling
  }
};

export const deleteFirmwareVersion = async (deleteParams: any = {}) => {
  try {
    const response = await firmwareApi.deleteFirmwareVersion(deleteParams);
    return response?.data || {};
  } catch (error) {
    console.error('Firmware version delete failed:', error);
    throw error;
  }
};

export const fetchDeviceListData = async (deviceType : string, entityId: any) => {
   if (!entityId) return;
  try {
    const response = await firmwareApi.getDeviceList(deviceType, entityId);
    return response?.data?.results || [];
  } catch (error) {
    console.error('Error fetching device list:', error);
    return [];
  }
};

export const applyNodeConfig = async (deviceList: string[]) => { 
  try {
    const response = await firmwareApi.refreshConfig(deviceList);
    return response?.data || [];
  } catch (error) {
    console.error('Error in refreshConfig:', error);
    return [];
  }
};
